<template>
  <v-app>
    <v-overlay 
      v-if="loadingPage"
      color="white"
      opacity="0.7"
      :absolute="false"
      z-index="50"
    >
      <div class="d-flex justify-center align-center" style="height: 100vh;">
        <div class="text-center">
          <v-progress-circular indeterminate color="primary" size="70" />
        </div>
      </div>
    </v-overlay>
    <v-navigation-drawer
      app
      v-model="drawer"
      mini-variant-width="76"
      :expand-on-hover="expandable"
      floating
      permanent
    >
    <vue-custom-scrollbar class="scroll-area" >
      <v-list-item class="px-2">
        <v-list-item-avatar @click="mini = !mini" tile>
          <img src="../assets/img/icon.svg" alt="logo-icon">
        </v-list-item-avatar>

        <v-list-item-title
          class="primary--text inter-title logo-container">
          <img src="../assets/img/logo_text.svg" alt="logo-text" class="logo-img">
            <!-- <h2>Menu</h2> -->
        </v-list-item-title>

        <v-btn
          small
          class="ml-2"
          icon
          v-if="!temporary"
          @click="handleSidebar"
        >
          <v-icon>{{ expandable ? 'menu' : 'clear'}}</v-icon>
        </v-btn>
      </v-list-item>

      <v-list
        dense
        rounded
        class="list-menu"
      >
      <div
        v-for="item in items"
        :key="item.title"
      >
        <v-list-item
          v-if="!item.children && item.visible"
          color="primary"
          link
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
            v-if="item.children && item.visible"
            :prepend-icon="item.icon"
        >
          <template v-slot:activator>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </template>
          <v-list-item
            v-for="(children, i) in item.children"
            :key="i"
              color="primary"
            link
            :to="children.link"
          >
            <v-list-item-title v-text="children.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </div>
      </v-list>
        </vue-custom-scrollbar>
    </v-navigation-drawer>

    <v-app-bar
      color="white"
      :class="expandable ? 'no-expand-toolbar' : null"
      class="mx-8 mt-4 mb-5"
      app
    >
      <v-app-bar-nav-icon
        v-if="temporary"
        @click="change">
      </v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-menu
        transition="slide-y-transition"
        :offset-y="true"
        bottom
        right
      >
        <template v-slot:activator="{ on }">
          <v-btn class="mr-5" v-on="on" text>{{lang}}</v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="lang">
            <v-list-item
              value="ES"
              @click="changeLanguage('es')">
              <v-list-item-title>ES</v-list-item-title>
            </v-list-item>
            <v-list-item
              value="EN"
              @click="changeLanguage('en')">
              <v-list-item-title>EN</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <small class="mr-2 username">
        {{userLogged.name}} {{userLogged.last_name}}
      </small>
      
        <v-menu
        transition="slide-y-transition"
        :offset-y="true"
        bottom
        right
      >
        <template v-slot:activator="{ on }">
          <v-avatar
            color="primary"
            v-on="on">
            <!-- <img
              src="https://cdn.vuetifyjs.com/images/john.jpg"
              alt="John"
            > -->
            <v-icon class="white--text">fas fa-user</v-icon>
          </v-avatar>
        </template>
        <v-list class="menu-avatar">
          <v-list-item @click="showDialog">
            <v-list-item-icon>
              <v-icon>fas fa-sign-out-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{$t('general.logout')}}</v-list-item-title>
          </v-list-item>
        </v-list>
        </v-menu>
    </v-app-bar>

    <v-content :class="expandable ? 'no-expand' : null" class="mt-5 mx-8">
      <v-row v-if="$route.meta.breadcrumb">
        <v-col>
          <h3 class="breadcrumb-title">{{$t(`${$route.meta.title}`)}} &nbsp;&nbsp;| </h3>
          <v-breadcrumbs
            class="breadcrumb-component"
            :items="$route.meta.breadcrumb">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item
                :href="item.href"
                :disabled="item.disabled"
              >
                {{$t(item.text)}}
              </v-breadcrumbs-item>
            </template>
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      <v-container fluid class="px-0 mt-n3">
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-dialog
      v-model="dialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">
          <h3 class="primary--text">{{$t('general.logout')}}</h3>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <p>
                {{$t('general.logoutMessage')}}
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="primary"
            @click="dialog = false"
          >
            {{$t('general.cancel')}}
          </v-btn>
          <v-btn
            color="primary"
            @click="logout"
            :loading="loading"
            :disabled="loading"
          >
            {{$t('general.accept')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
export default {
  name: 'dashboardComponent',
  components: {
    vueCustomScrollbar
  },
  data () {
    return {
      dialog: false,
      lang: 'ES',
      drawer: true,
      permanent: true,
      temporary: false,
      mini: true,
      loading: false,
      loadingPage: true,
      expandable: true
    }
  },
  watch: {
    'userLogged.lang' () {
      if (this.userLogged.lang === null || this.userLogged.lang === 'es') {
        this.lang = 'ES'
        this.$i18n.locale = 'es'
        this.$vuetify.lang.current = 'es'
        this.filterMenu()
      } else if (this.userLogged.lang === 'en') {
        this.lang = 'EN'
        this.$i18n.locale = 'en'
        this.$vuetify.lang.current = 'en'
        this.filterMenu()
      }
    },
    'userLogged.allPermissions' (val) {
      if (val) {
        this.loadingPage = false
        this.filterMenu()
      }
    }
  },
  computed: {
    items () {
      let menu = [
        {
          title: this.$t('general.home'),
          icon: 'fas fa-home',
          link: '/',
          rule: 'DASHBOARD',
          visible: false
        },
        {
          title: this.$t('general.contacts'),
          icon: 'fas fa-address-book',
          link: '/contacts',
          rule: 'CONTANT_PANEL',
          visible: false
        },
        {
          title: this.$t('general.company'),
          icon: 'fas fa-building',
          link: '/company',
          rule: 'COMPANIES',
          visible: false
        },
        {
          title: this.$t('general.sites'),
          icon: 'fas fa-map-marked-alt',
          link: '/sites',
          rule: 'SITES',
          visible: false
        },
        {
          title: this.$t('general.unitTypes'),
          icon: 'fas fa-boxes',
          link: '/unit-types',
          rule: 'UNIT_TYPES',
          visible: false
        },
        {
          title: this.$t('general.units'),
          icon: 'fas fa-truck',
          link: '/units',
          rule: 'UNITS',
          visible: false
        },
        {
          title: this.$t('general.unitMonitoring'),
          icon: 'mdi-heart-pulse',
          rule: 'UNITS', 
          link: '/unit-monitoring',
          visible: false
        },
        {
          title: this.$t('incidents.event'),
          icon: 'mdi-clipboard-pulse',
          link: '/event-log',
          rule: 'UNITS',
          visible: false
        },
        {
          title: this.$t('general.users'),
          icon: 'fas fa-user',
          link: '/users',
          rule: 'USERS',
          visible: false
        },
        {
          title: this.$t('general.tests'),
          icon: 'far fa-check-square',
          link: '/checklists',
          rule: 'QUESTIONNAIRES',
          visible: false
        },
        {
          title: this.$t('general.inspections'),
          icon: 'fas fa-search',
          link: '/inspections',
          rule: 'INSPECTIONS',
          visible: false
        },
        {
          title: this.$t('general.subscriptions'),
          icon: 'far fa-calendar-alt',
          link: '/subscriptions',
          rule: 'SUBSCRIPTIONS',
          visible: false
        },
        {
          title: this.$t('general.permissions'),
          icon: 'fas fa-user-lock',
          link: '/permissions',
          rule: 'PERMISSIONS',
          visible: false
        },
        {
          title: this.$t('general.history'),
          icon: 'fas fa-history',
          link: '/history',
          rule: 'INSPECTION_HISTORY',
          visible: false
        },
        {
          title: this.$t('general.historyTotal'),
          icon: 'fas fa-history',
          link: '/history-Total',
          rule: 'REPORT_COMPANIES',
          visible: false
        },
        {
          title: this.$t('general.notifications'),
          icon: 'mdi-bell',
          link: '/notifications',
          rule: 'NOTIFICATIONS',
          visible: false
        },
        {
          title: this.$t('general.reports'),
          icon: 'far fa-file-alt',
          link: '/reports',
          rule: 'REPORTS',
          visible: false
        },
      ]
      
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        menu.splice(1,1)
        menu.splice(10,1)
      } else if (this.userLogged.roles && this.userLogged.roles[0].name === 'INSPECTOR') {
        menu[6].visible = true
        menu.splice(7,1)
        menu.splice(5,1)
      }

      return menu;
    },
    userLogged () {
      return this.$store.state.userLogged
    }
  },
  created () {
    window.addEventListener('resize', () => {
      if (window.outerWidth <= 600) {
        this.mini = false
        this.temporary = true
        this.permanent = false
      } else {
        this.temporary = false
        this.permanent = true
      }
    })
    this.getLogged()
  },
  methods: {
    handleSidebar () {
      this.expandable = !this.expandable
    },
    change () {
      this.drawer = !this.drawer
    },
    filterMenu () {
      this.items.forEach(item => {
        if (this.userLogged.allPermissions.find(perm => perm === item.rule)) {
          if (item.title === 'Registro de incidencias' || item.title === 'Event log') return item.visible = false // Agregado manualmente para ocultar el menu de registro de incidencias
          item.visible = true
        }
      })
    },
    showDialog () {
      this.dialog = true
    },
    logout () {
      this.loading = true
      this.$store.dispatch('logout', {
        event: {
          context: this
        }
      })
    },
    getLogged () {
      this.$store.dispatch('userLogged', {event: {context: this}})
    },
    changeLanguage (lang) {
      this.$store.dispatch('changeLanguage', {
        event: {
          context: this,
          data: {
            language: lang
          }
        }
      })
    }
  }
}
</script>

<style scoped>
  .v-application {
    background-color: #F8F8F8;
  }
  .v-toolbar {
    border-radius: 10px;
  }
  .v-navigation-drawer {
    padding: 10px;
    box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
  }
  .inter-title {
    font-weight: bold;
  }
  .breadcrumb-title, .breadcrumb-component {
    display: inline-block;
  }
  .username {
    font-weight: bold;
  }
  .v-avatar {
    cursor: pointer;
  }
  .menu-avatar .v-list-item__icon {
    margin-right: 10px;
  }
  .menu-avatar .v-list-item:hover {
    cursor: pointer;
  }
  .list-menu {
    padding: 3px !important;
  }
  .scroll-area {
    position: relative;
    margin: auto;
    width: 100%;
    height: 100%;
  }
  .no-expand {
    padding-left: 76px !important;
  }
  .no-expand-toolbar {
    left: 76px !important;
  }
  .logo-container {
    display: flex;
    align-items: center;
  }
  .logo-img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
</style>